<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center"
    style="height: 400px;"
  >
    <el-button
      v-if="!show"
      type="text"
      :loading="loading"
    >正在生成...</el-button>
    <img :src="qrcodeUrl" />
    <h2>URL：{{ urlString }}</h2>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  data() {
    return {
      loading: true,
      show: false,
      qrcodeUrl: '',
      urlString: ''
    }
  },
  props: {
    bCode: String,
    pCode: String,
    tCode: String
  },
  methods: {
  },
  mounted() {
    // this.urlString = `https://www.ydtncpzlzs.cn:9000/index.html#/traceInquiry?b=${this.bCode}&p=${this.pCode}&t=${this.tCode}`
    this.urlString = `${process.env.VUE_APP_QR_URL}/index.html#/c?t=${this.tCode}`
    QRCode.toDataURL(
      this.urlString,
      { errorCorrectionLevel: 'H', version: 12 },
      (err, url) => {
        if (!err) {
          this.show = true
          this.qrcodeUrl = url
        }
      }
    )
  }
}
</script>
